// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3Z5MC-","button":"_3ZS4I-","forgotPassword":"_1_4Jk-","introText":"_2P1KO-"};